import { render, staticRenderFns } from "./investMonitor.vue?vue&type=template&id=45449eba&"
import script from "./investMonitor.vue?vue&type=script&lang=js&"
export * from "./investMonitor.vue?vue&type=script&lang=js&"
import style0 from "./investMonitor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports